import { useTranslation } from 'react-i18next';

import { Tooltip } from 'primereact/tooltip';

export default function WarningScientificProfileUrl() {
  const { t } = useTranslation();

  return (
    <span className="warning-scientific-profile pointer-events-auto ml-2">
      <i
        className="exclamation-circle-icon pi pi-exclamation-circle"
        data-pr-tooltip={t('projectProposal.general.researchHumanResources.noScientificProfileUrl')}
        data-pr-position="right"
        style={{ color: 'var(--red-600)', fontSize: 15 }}
      />
      <Tooltip target=".exclamation-circle-icon" />
    </span>
  );
}
